<mat-card appearance="outlined" class="mat-elevation-z2">
  <p>{{idsChecked.length}} {{getEntiteLabel()}} seront visibles dans la liste des {{getEntiteLabel()}}</p>
  <mat-card appearance="outlined">
    <mat-card-subtitle>
      Cliquer pour étendre les sous structures, seules celles cochées seront prises en compte, cocher ou décocher puis sauvegarder
    </mat-card-subtitle>
    <mat-card-content>
      <p8-tree-lazy #treestructures *ngIf="entiteTreeSvc"
                    [fieldsDisplay]="['name', 'code_manque']"
                    [svcLoad]="entiteTreeSvc"
                    [fctLoadParents]="entiteTreeSvc.listByType"
                    [argLoadParents]="'univ'"
                    [fctLoadChildren]="entiteTreeSvc.listByParent"
                    [argLoadChildren]="[entiteSvc.getEntiteCode(entityType), true]"
                    [mapModelFunction]="mapToStructureTreeModel"
                    [conditionExpand]="conditionExpand[entityType]"
                    [displayChecked]="true"
                    [checkedElements]="idsChecked"
                    [reload]="reload"
                    [buttonChoice]="false"
                    (onSelect)="onSelected($event)"
                    (onCheck)="onChecked($event, entityType)"
      ></p8-tree-lazy>
    </mat-card-content>
    <mat-divider></mat-divider><br/>
    <mat-card-content>
      <span *ngIf="idsChecked && idsChecked.length > 0">Composition de la liste des {{getEntiteLabel()}} :</span>
      <mat-list>
        <mat-list-item *ngFor="let entite of entities">
          {{entite?.entite_obj?.name}} ({{entite?.entite_obj?.code}})
        </mat-list-item>
      </mat-list>
    </mat-card-content>
    <mat-divider></mat-divider><br/>
    <mat-card-content fxLayoutAlign="end" fxLayout="row">
      <button mat-raised-button
              (click)="saved(entityType)"
              [disabled]="!idsChecked.length">Enregistrer les entités pour la liste des {{getEntiteLabel()}}</button>
    </mat-card-content>
  </mat-card>
</mat-card>
